import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DateRange, RangeCalendar } from '../dates/RangeCalendar';

export interface DateRangeFilterProps {
  value: DateRange | null;
  onChange?: (dateRange: DateRange | null) => void;
}

export function DateRangeFilter({ value, onChange }: DateRangeFilterProps) {
  const {
    palette: { greyscaleLight },
  } = useTheme();
  const { t } = useTranslation();

  return (
    <RangeCalendar
      label={t('dateRange')}
      labelProps={{
        sx: {
          color: value ? 'white' : 'inherit',
          backgroundColor: value ? greyscaleLight[600] : 'default',
        },
      }}
      value={value}
      onChange={onChange}
    />
  );
}
